import PGlobal from './PGlobal';
import StepLine from './StepLine';
import PreviewLine from './PreviewLine';
import AudioLine from './AudioLine';
import DataModel from './DataModel';

export const STEPLINE_HEIGHT = 12;
const PREVIEW_LINE_Y = 0;

class TimeLineDataModel extends DataModel{
    constructor(){
        super({
            playIndex : null,
            selectDict : {},
        });
        this.isMulti = false;
    }

    setData(index, dict){
        this.playIndex = index;
        dict = dict || {[index]:true}
        this.isMulti = Object.keys(dict).length > 1;
        this.selectDict = dict;
    }

    //action preview
    preview(index, dict){
        this.setData(index, dict);
        this.emit("preview", index);
    }

    //action play
    play(index, dict){
        this.setData(index, dict);
        this.emit("play", index);
    }
}

export default class Timeline extends PIXI.Container {
    constructor() {
        super();
        this._length = 0;
        this._page = 0;
        this._pasteable = false;
        this.mode = "video";
        this.onTimeChange = null;

        this.data = new TimeLineDataModel();

        this.preview_line = new PreviewLine(this.data);
        this.addChild(this.preview_line);

        this.audio_line = new AudioLine(this.data);
        this.audio_line.onChange = (index) => this.onAudioIndexChanged(index);
        this.audio_line.onTimeChange = (time) => this.onDailTimeChange(time);

        this.step_line = new StepLine(this.data);
        this.addChild(this.step_line);

        this.data.on("playIndex", this.onPlayIndexChanged, this);
        this.data.on("play", this.requestPlay, this);
        this.data.on("preview", this.requestPreview, this);
    }

    resize(w, h) {
        this.preview_line.y = PREVIEW_LINE_Y;
        this.preview_line.resize(w, h-STEPLINE_HEIGHT-PREVIEW_LINE_Y);

        this.audio_line.y = 0;
        this.audio_line.resize(w, h);

        this.step_line.x = 0;
        this.step_line.y = PGlobal.stageHeight - STEPLINE_HEIGHT;
        this.step_line.resize(w, STEPLINE_HEIGHT);
    }

    changeMode(mode) {
        this.mode = mode;
        var stepGroup = [this.preview_line, this.step_line];
        var audioGroup = [this.audio_line];
        if(this.mode == "video") {
            this._setChildrenState(stepGroup, audioGroup)
        }else {
            this.data.setData(this.data.playIndex);
            this._setChildrenState(audioGroup, stepGroup)
        }
    }

    _setChildrenState(showList, hideList){
        showList.forEach(v=>{
            this.addChild(v);
        })
        hideList.forEach(v=>{
            if(v.parent){
                v.parent.removeChild(v);
            }
        })
    }

    setTemplateMode(bool) {
        this.preview_line.templateMode = bool;
    }

    onDailTimeChange(time) {
        if(this.onTimeChange) {
            this.onTimeChange(time);
        }
    }

    setTime(time) {
        if(this.mode == "audio") {
            this.audio_line.setTime(time);
        }
    }

    onPlayIndexChanged(){
        const index = this.data.playIndex;
        if(index == null){ return;}

        if(this.mode == "video") {
            //setTimeout(() => this.freshEditBar(), 500);
        }else {

        }
    }

    onAudioIndexChanged(index){
        this.data.setData(index);
        let stepIndex = new proto.com.proto.editortimeline.MStepIndex([index, this._page]);
        PGlobal.m.send(SCENE, 2, 6, stepIndex);
        //
        this.sendSelectStep();
    }

    requestPreview(index){
        let stepIndex = new proto.com.proto.editortimeline.MStepIndex([index, this._page]);
        PGlobal.m.send(SCENE, 2, 7, stepIndex);
    }

    requestPlay(index){
        let stepIndex = new proto.com.proto.editortimeline.MStepIndex([index, this._page]);
        PGlobal.m.send(SCENE, 2, 6, stepIndex);
        //
        this.sendSelectStep();
        this.onPlayIndexChanged();
        this.showEditBar();
    }

    sendSelectStep(){
        let int32Array = new proto.com.proto.s.MInt32Array();
        let ary = [];
        let dict = this.data.selectDict;
        const indeies = Object.keys(dict).map(v=>{return parseInt(v)});
        indeies.sort((a, b)=>{return a - b;})
        indeies.forEach(key =>{
            const index = parseInt(key);
            ary.push(index);
        });
        int32Array.setValueList(ary);
        PGlobal.m.send(SCENE, 2, 12, int32Array);
    }

    changeStep(stepIndex) {
        if(stepIndex.step !== this.data.playIndex){
            this.data.setData(stepIndex.step);
        }
        this._page = stepIndex.page;
        
    }

    setTrkData(data) {
        this.audio_line.setTrkData(data);
    }
    /**
     * 选择播放， 步数变化 会影响选择
     */

    setData(stepsInfo) {
        this.audio_line.setStepData(stepsInfo.stepsList);
        this.length = stepsInfo.stepsList.length;

        this.data.playIndex = null;
        this.changeStep(stepsInfo.selected);
    }

    set length(len) {
        this._length = len;
        this.preview_line.length = this._length;
        this.step_line.length = this._length;
    }

    get length() {
        return this._length;
    }

    set selected(sel) {
        this.data.playIndex = sel;
    }

    get selected() {
        return this.data.playIndex;
    }

    get page() {
        return this._page;
    }

    hideEditBar(){
        PGlobal.m.send(CORE, 1, 7);
    }
    
    showEditBar() {
        let tx = this.preview_line.getSelectedPosition().x;
        let ty = 4;
        PGlobal.m.send(CORE, 1, 6, new proto.com.proto.s.MTimelineToolbar([Math.floor(tx), Math.floor(ty), this.getToolbarItems()]));
    }

    getToolbarItems() {
        let result = [];
        if(this.data.isMulti){
            result.push(["timeline_template_save", 4]);
            result.push(["delete", 4]);
            return result;
        }
        result.push(["insertForward", 0]);
        if(this.data.playIndex != this._length-1) {
            result.push(["insertBack", 1]);
            result.push(["copy", 2]);
            if(this._pasteable) result.push(["paste", 3]);
            result.push(["timeline_template_save", 4]);
            result.push(["delete", 4]);
        }
        
        return result;
    }

    set pasteable(b) {
        this._pasteable = b;
        this.showEditBar();
    }
}



// WEBPACK FOOTER //
// ./src/common/scripts/pixi/Timeline.js